import React from 'react';
import PropTypes from 'prop-types';
import { Container, Title, Description } from './PageHeader.styles';

const PageHeader = ({ title, description }) => (
  <Container>
    <Title>{title}</Title>
    {description && <Description>{description}</Description>}
  </Container>
);

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
};

PageHeader.defaultProps = {
  description: null,
};

export default PageHeader;
